/**
 * Triton does not maintain standart wss endpoint
 * as a result txns confirmation stuck
 * there is an alternative called Whirligig that works fast
 * This method builds the proper wss endpoint to work with Whirligig
 */
export const getWsEndpoint = (endpoint: string) => {
  return endpoint.includes("rpcpool")
    ? `${endpoint.replace("https://", "wss://")}/whirligig`
    : undefined;
};
